<template>
  <el-col :span="7"
          class="processed-skus__indicator"
          :class="[{'align-center' : !showProcessedCount}, indicatorType]">
    <div class="type">
      {{ indicatorTitle }}
    </div>
    <div :class="[{'info' : showProcessedCount}, indicatorType]"
         @click="handleAddToPool">
      <span v-if="showProcessedCount" class="add-to-pool">{{ $t('ADD TO POOL') }}</span>
      <div class="processed-skus__indicator-count">
        <span class="counts">{{ counts[indicatorType].total }}</span>
        <i v-if="showProcessedCount" class="mdi mdi-arrow-right-thin info-arrow" />
        <transition v-if="showProcessedCount"
                    mode="out-in"
                    enter-active-class="animated bounceIn">
          <span :key="counts[indicatorType].processed" class="processed-count">
            <i class="mdi mdi-check-circle-outline" />
            {{ counts[indicatorType].processed }}
          </span>
        </transition>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: 'Indicator',
  props: {
    showProcessedCount: {
      type: Boolean,
      default: false
    },
    counts: {
      type: Object,
      required: true
    },
    indicatorType: {
      type: String,
      default: ''
    },
    indicatorTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleAddToPool() {
      if (this.showProcessedCount) {
        this.$emit('addToPoolBulkMode');
      }
    }
  }
};
</script>

<style lang="scss">
.processed-skus__indicator {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-end;
  font-size: 14px;

  &-count {
    display: flex;
    align-items: baseline;
    justify-content: space-around;
    width: 100%;
    margin-top: 10px;

    .counts {
      flex: 1;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
    }

    .processed-count {
      flex: 1;
      font-weight: 600;
      text-align: center;
      transition-duration: 0.1s;

      i {
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }

  .type {
    flex: 0 0 100%;
    padding: 1px 0;
    margin-bottom: 5px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 4px;
  }

  .info {
    width: 100%;
    margin-top: 20px;

    .add-to-pool,
    .info-arrow {
      display: none;
    }

    &:hover {
      margin-top: 0;
      color: #fff;
      cursor: pointer;

      .add-to-pool {
        display: inherit;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
      }

      .info-arrow {
        display: inherit;
        font-size: 16px;
        color: #fff;
      }

      &.normal {
        background: #4a90e2;
        border-radius: 5px;

        .mdi-check-circle-outline {
          &::before {
            color: #4a90e2;
            background: #fff;
            border-radius: 20px;
          }
        }
      }

      &.unrecognized {
        background: #51cfc3;
        border-radius: 5px;

        .mdi-check-circle-outline {
          &::before {
            color: #51cfc3;
            background: #fff;
            border-radius: 20px;
          }
        }
      }

      &.meta {
        background: #eddb02;
        border-radius: 5px;

        .mdi-check-circle-outline {
          &::before {
            color: #eddb02;
            background: #fff;
            border-radius: 10px;
          }
        }
      }
    }
  }

  &.normal {
    color: $brilliantAzure;

    .type {
      background-color: rgba($brilliantAzure, 0.4);
    }
  }

  &.name {
    font-size: 14px;
    font-weight: 600;
    color: #9e9e9e;
  }

  &.unrecognized {
    color: #57e0c1;

    .type {
      background-color: rgba(#57e0c1, 0.4);
    }
  }

  &.meta {
    color: #ecd930;

    .type {
      background-color: rgba(#ecd930, 0.3);
    }
  }

  &.non-sku {
    color: #f60;

    .type {
      background-color: rgba(#f60, 0.3);
    }
  }

  &.align-center {
    justify-content: center;
  }
}
</style>
